<template>
    <div class="wrapper" ref="wrapper" :style="{ height: wrapperHeight + 'px' }">
        <ul v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="50" v-if="list.length>0">
            <li class="flex" v-for="item in list" :key="item.id">
                <div class="avatar" :style="{backgroundImage:`url(${item.userIcon?item.userIcon:head})`}"></div>
                <div class="bubble">
                    <div class="flex-default info">
                        <span>{{item.username}}</span>
                        <time>{{getDate(item.date) | dateCompared}}</time>
                    </div>

                    <!-- 文字 -->
                    <div class="content" v-if="item.content" v-html="item.content"></div>

                    <!--  img -->
                    <div class="content" v-if="!!item.image">
                        <img :src="item.image" alt="" style="width:60vw;height:35vw" @click="showGallary(item.image)">
                    </div>

                    <!-- 视频 -->
                    <div class="video-wrap content video-content"  v-if="!!item && !!item.medias && item.medias.type === 'video'">
                        <video
                            :src="item.medias.url"
                            :poster="item.medias.image"
                            style="object-fit:fill" 
                            controlsList="nodownload"
                            x5-playsinline
                            playsinline
                            webkit-playsinline
                            controls
                            preload="auto">
                        </video>
                    </div>

                    <!-- 音频 -->
                    <div class="content" v-else-if="!!item && !!item.medias && item.medias.type === 'audio'">
                        <audio :src="item.medias.url" controls controlsList="nodownload" oncontextmenu="return false"></audio>
                    </div>

                    <div class="reply" v-for="replie in item.replies" :key="replie.id">
                        <p><span>回复：</span><span>{{replie.username}}</span>{{replie.content}}</p>
                    </div>
                    
                </div>
            </li>
        </ul>
        <div v-else :class="['null-data', 'share-null-data']"></div>
         <p v-if="loading" class="loading">
            <mt-spinner type="fading-circle"></mt-spinner>
            加载中...
        </p>
        <p v-if="isAll" class="loading">已显示全部内容</p>

    </div>
</template>

<script>
import head from 'images/default-head.png'
import { Toast } from 'mint-ui'
import { intfc_prefix_common } from 'constants/project'

export default {
    data () {
        return {
            head,
            list: [],
            loading: false,
            isAll: false,
            wrapperHeight: 0,
            data: {
                page: {
                    last: 2
                }
            },
            time: '',
            next: 1,
            clock: null,
            el: null
        }
    },

    created () {
        this.getComment(this.$route.params.id)

        this.el = setInterval(() => {
            this.getNewComment(this.$route.params.id)
        }, 30000)
    },

    mounted() {
        this.$nextTick(() => {
            this.wrapperHeight = document.documentElement.clientHeight - this.$refs.wrapper.getBoundingClientRect().top
        })
    },

    destroyed () {
        clearInterval(this.el)
    },

    methods: {
         getComment (articleId) {
            this.loading = true
            const pageToken = this.next * 1
            const pageLast = this.data.page.last * 1
            if (pageToken > pageLast) {
                this.loading = false
                this.isAll = true
                return false
            }
            this.$axios.get(`${intfc_prefix_common}/api/v2/live/liveRoomComment?articleId=${articleId}&pageToken=${pageToken}`)
                .then(res=> {
                    const result = res
                    if (res.code === 0) {
                        this.data = result
                        this.time = result.item.time
                        this.loading = false
                        if (this.data.items && this.data.items.length > 0) {
                            this.data.items.map((item) => {
                                this.list.push(item)
                            })
                        
                            this.next++
                        }
                    } else {
                        Toast(res.msg)
                        this.loading = false
                    }
                })
        },

        getNewComment (articleId) {
            this.$axios.get(`${intfc_prefix_common}/api/v2/live/newLiveRoomComment?articleId=${articleId}&time=${this.time}&sysCode="live"`)
                .then(res=> {
                    const result = res.items
                    if (res.code === 0 ) {
                        if(!result){
                            return
                        }
                        this.time = res.item.time
                            result.map(item => {
                                this.list.push(item)
                            })
                    } else {
                        Toast(res.msg)
                    }
                })
        },

        getDate: (date) => {
            return date.slice(0, -2) + ':00'
        },

        loadMore() {
            if (this.isAll || this.loading) return false
            
            this.getComment(this.$route.params.id)
        },
        showGallary(src) {
            this.$emit('handleGallary',src)
        }

    }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
    @import "~src/stylus/mixin"

    .wrapper
        overflow auto 
        padding 0 20px
        -webkit-overflow-scrolling touch
        ul 
            margin-top 60px
            padding-bottom 50px
            li 
                margin-bottom 30px
                .avatar 
                    width 70px
                    height 70px
                    background no-repeat 50%/100%
                    border-radius 999px
                    background-size cover 
                .bubble::after
                    position: absolute
                    content: ""
                    width: 0
                    height: 0
                    left: -8px
                    top: 16px
                    border-top: 28px solid transparent
                    border-right: 28px solid #f6f6f6 
                    background-color: #f6f6f6
                    -webkit-transform: rotateZ(45deg)  
                .bubble
                    box-sizing border-box
                    max-width 528px
                    min-width 266px
                    padding 16px 24px
                    position relative
                    margin-left 20px
                    border-radius 8px
                    background #f6f6f6
                    color #222222
                    font-size 32px
                    .info 
                        // display flex
                        span 
                            font-size 28px
                            color #858585
                            flex 1
                            overflow hidden
                            white-space nowrap
                            text-overflow ellipsis 
                        time 
                            margin-left 10px
                            font-size 22px
                            color #9B9B9B    
                    .content 
                        margin-top 5px
                        line-height 52px
                        audio 
                            width 100%
                        img 
                            width 100%
                    .video-content
                        width 600px
                        height 360px
                        video 
                            display inline-block
                            width 100%
                            height 100%            
                .reply 
                    color #9B9B9B
                    font-size 28px
                    p 
                        line-height 52px
                    span:nth-of-type(1)
                        color #C11531
                    span:nth-of-type(2)
                        color #858585
                        margin-right 20px
            .reverse 
                flex-direction row-reverse
                .bubble 
                    margin-left 0
                    margin-right 20px
                    background #FFF1F1
                    border 1px solid #FEEDE8
     .loading 
        padding-bottom 50px
        text-align center
        font-size 24px
        color #AFAFAF
        height 56px
        line-height 56px
    .null-data 
        width 560px
        height 560px
        margin 50px auto 0
    .app-null-data 
        background url("~images/null.png") no-repeat 50%/100%
    .share-null-data 
        background url("~images/null.png") no-repeat 50%/100%
</style>


// WEBPACK FOOTER //
// interactive.vue?52d0d330